// src/config/env.config.js

export const ENV = {
    EMAILJS: {
      SERVICE_ID: process.env.REACT_APP_EMAILJS_SERVICE_ID || import.meta.env?.VITE_EMAILJS_SERVICE_ID,
      TEMPLATE_ID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || import.meta.env?.VITE_EMAILJS_TEMPLATE_ID,
      PUBLIC_KEY: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || import.meta.env?.VITE_EMAILJS_PUBLIC_KEY,
    },
    STRIPE: {
      PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || import.meta.env?.VITE_STRIPE_PUBLISHABLE_KEY,
    },
    API: {
      BASE_URL: process.env.REACT_APP_API_BASE_URL || import.meta.env?.VITE_API_BASE_URL || '',
    },
  };
  
  export default ENV;